import { Component, type ReactNode } from 'react';
import { StandalonePage } from './standalone-page';
import { StatusPage } from './status-page';

interface AppErrorBoundaryState {
  hasError: boolean;
}

/** ErrorBoundary global para erros de renderização fora das rotas. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, AppErrorBoundaryState> {
  override state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <StandalonePage>
          <StatusPage
            title="Algo deu errado"
            description="Recarregue a página. Se o problema continuar, contate o suporte."
          />
        </StandalonePage>
      );
    }
    return this.props.children;
  }
}
